import React, { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';

const ConnectionStatus = () => {
  const [connectionStatus, setConnectionStatus] = useState('checking');
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkConnection = async () => {
      try {
        // Test basic Supabase connection
        const { data, error } = await supabase?.from('communes')?.select('count')?.limit(1)?.single();
        
        if (error && error?.code === 'PGRST116') {
          // No rows returned but connection works
          setConnectionStatus('connected');
          setError(null);
        } else if (error) {
          setConnectionStatus('error');
          setError(error?.message);
        } else {
          setConnectionStatus('connected');
          setError(null);
        }
      } catch (err) {
        setConnectionStatus('disconnected');
        if (err?.message?.includes('Failed to fetch')) {
          setError('Supabase project may be paused or deleted. Check your dashboard.');
        } else {
          setError(err?.message || 'Connection failed');
        }
      }
    };

    checkConnection();
    
    // Check connection every 30 seconds
    const interval = setInterval(checkConnection, 30000);
    
    return () => clearInterval(interval);
  }, []);

  if (connectionStatus === 'checking') {
    return (
      <div className="fixed top-4 right-4 bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-2 rounded-lg flex items-center gap-2 z-50">
        <div className="animate-spin w-4 h-4 border-2 border-yellow-500 border-t-transparent rounded-full"></div>
        <span className="text-sm">Checking connection...</span>
      </div>
    );
  }

  if (connectionStatus === 'disconnected' || connectionStatus === 'error') {
    return (
      <div className="fixed top-4 right-4 bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded-lg max-w-md z-50">
        {error && (
          <p className="text-xs text-red-600">{error}</p>
        )}
        <p className="text-xs text-red-500 mt-1">
          Check your .env file and Supabase project status
        </p>
      </div>
    );
  }

  return null;
};

export default ConnectionStatus;